import { Constants } from "@eagerdog/constants";

/** Results that don't need a time: the dog didn't finish or didn't run. */
export const RAT_RACE_TIME_OPTIONAL_RESULTS: string[] = [
  Constants.score_result_type.not_qualified,
  Constants.score_result_type.disqualified,
  Constants.score_result_type.excused,
  Constants.score_result_type.absent,
];

export interface IRatRaceScore {
  //
  /**
   * Constants.score_result_type:
   * Qualified
   * NQ
   */
  result_type: string;

  /** Seconds. Not set for NQ / DQ / Excused / Absent runs entered without a time. */
  time?: number;

  fault_count: number;

  // only for "Fantastic Five"
  rats_found?: number;
  // false_alerts => use fault_count
}
